import React, { useEffect } from "react";
import { loadGoogleMapsSoon } from "./utils/googleMaps";
import AppRoutes from "./AppRoutes";
import { useAndroidBackButton, useNetworkStatus, useHideSplash, OfflineBanner, ExitToast } from "./hooks/useCapacitor";

import { BrowserRouter } from "react-router-dom";
import { loadCategoryConfig } from "./utils/carCategory";
import { loadPlatformConfig } from "./utils/platformConfig";
import { loadExtraCities } from "./utils/extraCities";
import { loadAdsTag } from "./utils/adsTag";
import AppVersionChecker from "./components/AppVersionChecker";
import WalletGateHost from "./components/wallet/WalletGateHost";
import OnBehalfHost from "./components/OnBehalfHost";
import BusinessLimitHost from "./components/BusinessLimitHost";


function AppShell() {
  // Capacitor hooks — safe on web (lazy-loaded)
  const { showExitToast } = useAndroidBackButton();
  const { isOnline, retrying, retry } = useNetworkStatus();
  useHideSplash();

  return (
    <>
      <AppVersionChecker />
      <OfflineBanner isOnline={isOnline} retrying={retrying} retry={retry} />
      <ExitToast show={showExitToast} />
      <AppRoutes />
      {/* Asks before a call that costs money, and adds money when it is needed. */}
      <WalletGateHost />
      {/* Desk staff: "For myself / For a customer" before a Call (mock CallBook_1). */}
      <OnBehalfHost />
      {/* One business call every 6 hours (mock B2BLimit_1). */}
      <BusinessLimitHost />
    </>
  );
}

export default function App() {
  useEffect(() => {
    loadCategoryConfig().catch(err => console.error("Config init error:", err));
    loadPlatformConfig().catch(err => console.error("Platform config init error:", err));
    // Cities an admin added for towns businesses asked for (mock City_1).
    loadExtraCities();
    // Google Ads conversions (off until the tag id is set in the platform settings).
    loadAdsTag();
    /* Google Maps after the first screen, not before it (27 Oct 2026): <LoadScript>
       drew nothing until Maps had downloaded - ~18 s of blank screen on a slow phone. */
    loadGoogleMapsSoon();
    const interval = setInterval(() => {
      loadCategoryConfig().catch(err => console.error("Config poll error:", err));
      loadPlatformConfig().catch(err => console.error("Platform config poll error:", err));
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
